function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
/**
 * RemoteAppWrapper provides CSS isolation for remote micro-frontend applications.
 *
 * This component prevents CSS conflicts between the host app (Material UI)
 * and remote apps (Tailwind, Bootstrap, etc.) by:
 *
 * 1. Creating a scoped container with CSS isolation
 * 2. Intercepting and scoping dynamically injected styles from remote apps
 * 3. Adding data attributes to track style ownership
 *
 * The remote app's styles are prefixed with a unique selector to prevent
 * them from affecting the host application's styles.
 */
var RemoteAppWrapper = function RemoteAppWrapper(_ref) {
    var children = _ref.children, _ref$appName = _ref.appName, appName = _ref$appName === void 0 ? 'remote-app' : _ref$appName, _ref$enableStyleScopi = _ref.enableStyleScoping, enableStyleScoping = _ref$enableStyleScopi === void 0 ? true : _ref$enableStyleScopi;
    var containerRef = useRef(null);
    var scopingPrefix = "[data-remote-app=\"".concat(appName, "\"]");
    useEffect(function () {
        if (!enableStyleScoping)
            return;
        // Create a protective style sheet FIRST to prevent remote styles from affecting host
        var protectionStyle = document.createElement('style');
        protectionStyle.dataset.protection = appName;
        protectionStyle.textContent = "\n\t\t\t/* Protect host app from remote app's global resets */\n\t\t\tbody:not([data-remote-app=\"".concat(appName, "\"]),\n\t\t\thtml:not([data-remote-app=\"").concat(appName, "\"]) {\n\t\t\t\t/* Preserve Material-UI defaults */\n\t\t\t\tfont-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif !important;\n\t\t\t\tline-height: 1.43 !important;\n\t\t\t}\n\t\t");
        document.head.appendChild(protectionStyle);
        // Mark all existing styles as host before remote app loads
        var _iterator = _createForOfIteratorHelper(document.querySelectorAll('style')), _step;
        try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var style = _step.value;
                if (!style.dataset.app && !style.dataset.remoteApp && !style.dataset.protection) {
                    style.dataset.app = 'host';
                }
            }
            // Track styles created by this remote app for cleanup
        }
        catch (err) {
            _iterator.e(err);
        }
        finally {
            _iterator.f();
        }
        var remoteAppStyles = new Set();
        remoteAppStyles.add(protectionStyle);
        // Track styles we've processed to avoid re-scoping
        var processedStyles = new WeakSet();
        /**
         * Determines if a style element belongs to the host app
         * Host styles are identified by:
         * 1. Having data-app="host" attribute
         * 2. Having data-mui or other Material-UI markers
         * 3. Being injected by webpack style-loader for host
         */
        var isHostStyle = function isHostStyle(styleElement) {
            // Check explicit host marker
            if (styleElement.dataset.app === 'host') {
                return true;
            }
            // Check for Material-UI injected styles
            if (styleElement.dataset.mui || styleElement.dataset.emotion || styleElement.dataset.styled || styleElement.dataset.jss) {
                // Mark it as host for future checks
                styleElement.dataset.app = 'host';
                return true;
            }
            // Check if the style element's content suggests it's from Material-UI
            try {
                var _styleElement$textCon;
                var content = (_styleElement$textCon = styleElement.textContent) !== null && _styleElement$textCon !== void 0 ? _styleElement$textCon : '';
                if (content.includes('.MuiBox-') || content.includes('.MuiStack-') || content.includes('.MuiTypography-') || content.includes('.MuiButton-') || content.includes('.MuiAppBar-') || content.includes('.MuiDrawer-') || content.includes('.MuiPaper-') || content.includes('.MuiMenu-') || content.includes('.MuiSkeleton-') || content.includes('.MuiDivider-') || content.includes('.MuiIconButton-') || content.includes('.Mui')) {
                    styleElement.dataset.app = 'host';
                }
            }
            catch (_unused) {
                // If we can't read content, assume it's host to be safe
                return true;
            }
            return false;
        };
        /**
         * Processes a CSS style rule by scoping its selector
         */
        var processCSSStyleRule = function processCSSStyleRule(rule, scopingPrefix) {
            var selector = rule.selectorText;
            // Block global resets
            var globalResets = ['*', '*, ::before, ::after', '*, *::before, *::after', 'html', 'body', ':root'];
            if (globalResets.includes(selector)) {
                return ''; // Skip global resets
            }
            // Scope the selector
            var scopedSelector = selector.split(',').map(function (sel) {
                return "".concat(scopingPrefix, " ").concat(sel.trim());
            }).join(', ');
            return "".concat(scopedSelector, " { ").concat(rule.style.cssText, " }");
        };
        /**
         * Processes a CSS media rule by scoping its nested rules
         */
        var processCSSMediaRule = function processCSSMediaRule(rule, scopingPrefix) {
            var mediaRules = [];
            var _iterator2 = _createForOfIteratorHelper(rule.cssRules), _step2;
            try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var mediaRule = _step2.value;
                    if (mediaRule instanceof CSSStyleRule) {
                        var scopedSelector = mediaRule.selectorText.split(',').map(function (selector) {
                            return "".concat(scopingPrefix, " ").concat(selector.trim());
                        }).join(', ');
                        mediaRules.push("".concat(scopedSelector, " { ").concat(mediaRule.style.cssText, " }"));
                    }
                }
            }
            catch (err) {
                _iterator2.e(err);
            }
            finally {
                _iterator2.f();
            }
            return "@media ".concat(rule.conditionText, " { ").concat(mediaRules.join(' '), " }");
        };
        /**
         * Processes all CSS rules in a stylesheet
         */
        var processStyleRules = function processStyleRules(sheet, scopingPrefix) {
            var rules = [];
            var _iterator3 = _createForOfIteratorHelper(sheet.cssRules), _step3;
            try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var rule = _step3.value;
                    if (rule instanceof CSSStyleRule) {
                        var processedRule = processCSSStyleRule(rule, scopingPrefix);
                        if (processedRule) {
                            rules.push(processedRule);
                        }
                    }
                    else if (rule instanceof CSSMediaRule) {
                        rules.push(processCSSMediaRule(rule, scopingPrefix));
                    }
                    else {
                        // Keep other rules as-is (keyframes, font-face, etc.)
                        rules.push(rule.cssText);
                    }
                }
            }
            catch (err) {
                _iterator3.e(err);
            }
            finally {
                _iterator3.f();
            }
            return rules;
        };
        /**
         * Scopes CSS rules by prefixing selectors with the container's data attribute
         */
        var scopeStyleElement = function scopeStyleElement(styleElement) {
            // Skip if already processed
            if (processedStyles.has(styleElement))
                return;
            // Skip if it's a host app style
            if (isHostStyle(styleElement))
                return;
            // Skip if already scoped
            if (styleElement.dataset.scoped) {
                return;
            }
            try {
                var sheet = styleElement.sheet;
                if (!sheet) {
                    // Mark as processed even if we can't access the sheet
                    processedStyles.add(styleElement);
                    return;
                }
                // Use helper function to process all rules
                var rules = processStyleRules(sheet, scopingPrefix);
                // Replace the original styles with scoped ones
                if (rules.length > 0) {
                    styleElement.textContent = rules.join('\n');
                    styleElement.dataset.remoteApp = appName;
                    styleElement.dataset.scoped = 'true';
                    processedStyles.add(styleElement);
                    remoteAppStyles.add(styleElement);
                }
            }
            catch (error) {
                // CORS or other access errors - mark as processed to avoid retry
                console.warn("Could not scope style element for ".concat(appName, ":"), error);
                processedStyles.add(styleElement);
            }
        };
        /**
         * Handle mutation observer callback for new style elements
         */
        var handleMutations = function handleMutations(mutations) {
            var _iterator4 = _createForOfIteratorHelper(mutations), _step4;
            try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    var mutation = _step4.value;
                    var _iterator5 = _createForOfIteratorHelper(mutation.addedNodes), _step5;
                    try {
                        var _loop = function _loop() {
                            var node = _step5.value;
                            if (node.nodeName === 'STYLE') {
                                var styleElement = node;
                                // Give the browser time to parse the stylesheet
                                setTimeout(function () {
                                    return scopeStyleElement(styleElement);
                                }, 0);
                            }
                        };
                        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                            _loop();
                        }
                    }
                    catch (err) {
                        _iterator5.e(err);
                    }
                    finally {
                        _iterator5.f();
                    }
                }
            }
            catch (err) {
                _iterator4.e(err);
            }
            finally {
                _iterator4.f();
            }
        };
        /**
         * Watch for new style elements being added to the DOM
         */
        var observer = new MutationObserver(handleMutations);
        // Watch for new styles
        observer.observe(document.head, {
            childList: true,
            subtree: true
        });
        // Cleanup function: remove remote app styles when unmounting
        return function () {
            observer.disconnect();
            // Remove all styles created by this remote app
            var _iterator6 = _createForOfIteratorHelper(remoteAppStyles), _step6;
            try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                    var style = _step6.value;
                    style.remove();
                }
            }
            catch (err) {
                _iterator6.e(err);
            }
            finally {
                _iterator6.f();
            }
            remoteAppStyles.clear();
        };
    }, [enableStyleScoping, appName, scopingPrefix]);
    return /*#__PURE__*/ React.createElement(Box, {
        ref: containerRef,
        "data-remote-app": appName,
        sx: {
            // Establish a fresh styling context for the remote app
            // This resets all inherited styles
            position: 'relative',
            display: 'block',
            width: '100%',
            minHeight: '100vh',
            height: '100%',
            // CSS isolation to create a new stacking context
            isolation: 'isolate',
            // Reset box model
            boxSizing: 'border-box',
            margin: 0,
            padding: 0,
            // Remove contain property to allow proper overflow and positioning
            overflow: 'auto',
            // Reset some common properties that might conflict
            '& *': {
                boxSizing: 'border-box'
            },
            // Reset Typography that might be inherited from Material UI
            '& p, & h1, & h2, & h3, & h4, & h5, & h6': {
                margin: 0
            }
        }
    }, children);
};
export default RemoteAppWrapper;
